import { render, staticRenderFns } from "./BaseFull.vue?vue&type=template&id=32b9008b&scoped=true"
import script from "./BaseFull.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFull.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseFull.vue?vue&type=style&index=0&id=32b9008b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b9008b",
  null
  
)

export default component.exports